import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Apollo, gql} from 'apollo-angular';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {catchError, EMPTY, exhaustMap, filter, map, Subject, Subscription} from 'rxjs';
import {BuilderTemplateInput} from '../../graphql/globalTypes';
import {ErrorService} from '../../services/error.service';
import {TemplateService_GetTemplateItem_templateItem} from '../../services/__generated__/TemplateService_GetTemplateItem';
import {
  PasswordProtect_CreateUpdateBuilderTemplate,
  PasswordProtect_CreateUpdateBuilderTemplateVariables,
} from './__generated__/PasswordProtect_CreateUpdateBuilderTemplate';

const UPDATE_PASSWORD_MUTATION = gql`
  mutation PasswordProtect_CreateUpdateBuilderTemplate($input: BuilderTemplateInput) {
    updateOrCreateBuilderTemplate(input: $input) {
      templateItem {
      id
      title
      createPassword
    }
    error
  }
}
`;

@Component({
  selector: 'app-password-protect',
  templateUrl: './password-protect.component.html',
  styleUrls: ['./password-protect.component.scss'],
  standalone: false,
})
export class PasswordProtectComponent implements OnInit, OnDestroy {
  templateItem: TemplateService_GetTemplateItem_templateItem | null = null;
  passwordInput = new UntypedFormControl();
  submit$ = new Subject<string | null>();
  private subscriptions: Subscription[] = [];

  constructor(
    private bsModalRef: BsModalRef,
    private apollo: Apollo,
    private errService: ErrorService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.submit$
        .pipe(
          map(() => [this.templateItem?.id, this.passwordInput.value]),
          filter(([id]) => id),
          exhaustMap(([id, pw]) => {
            const mutationInput: BuilderTemplateInput = {
              id: id,
              createPassword: pw,
            };

            return this.apollo.mutate<
              PasswordProtect_CreateUpdateBuilderTemplate,
              PasswordProtect_CreateUpdateBuilderTemplateVariables
            >({
              mutation: UPDATE_PASSWORD_MUTATION,
              variables: {
                input: mutationInput,
              },
            });
          }),
          catchError(error => {
            this.errService.handleDefault(error);
            return EMPTY;
          }),
        )
        .subscribe(response => {
          const error = response.data?.updateOrCreateBuilderTemplate.error;
          if (error) {
            this.toastr.error($localize`An error has occurred: ${error}.`);
          } else {
            this.toastr.success($localize`Password updated.`);
          }
          this.bsModalRef.hide();
        }),
    );
  }

  closeModal(): void {
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
